import { createNode } from '@glueapp/graph-types';

export const Divide = createNode({
    id: 'Divide',
    name: 'Divide',
    description: 'A Node for dividing numbers',
    aiDescription:
        'Divides Number by Divider. Connect values to "Number" and "Divider" input ports; the "Result" output port provides the quotient. Division by zero returns the original Number.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {
        Number: { kind: 'number' },
        Divider: { kind: 'number' },
    },
    outPorts: {
        Result: { kind: 'number' },
    },
    execute: function (input) {
        const dividerValue = input.inPorts.Divider;
        if (dividerValue !== 0) {
            return { output: { Result: input.inPorts.Number / dividerValue } };
        } else {
            return { output: { Result: input.inPorts.Number } };
        }
    },
});
